<script lang="ts">
  export let goalType: string
  export let name: string
  export let borders = false

  const opts = {
    long_term_goal: { css: "border-long-term-goal", name: "Long Term Goal" },
    annual_goal: { css: "border-annual-goal", name: "Annual Goal" },
    quarterly_goal: { css: "border-quarterly-goal", name: "Quarterly Goal" },
    task: { css: "border-task", name: "Task" }
  }

  const sel = opts[goalType] || opts["long_term_goal"]
  const pre = goalType.replace(/_/g, "-")

  const bg = {
    long_term_goal: "#9400EE",
    annual_goal: "#02C5B9",
    quarterly_goal: "#FFBB36",
    task: "#4D4ADF"
  }[goalType]
</script>

<div
  class="border-t border-b border-r relative"
  class:border-transparent={!borders}
>
  <div
    class="w-5 h-5 rounded-full flex items-center justify-center absolute top-8 -left-1.5"
    style="background-color: {bg}"
  >
    <div class="bg-white w-4 h-1"></div>
  </div>

  <div
    class="p-4 w-full bg-white flex justify-start border-l-8 {sel.css} max-w-xl"
  >
    <div class="px-4 py-1">
      <p class="text-lg">
        {#if name}
          <span class="font-bold">
            {name}
          </span>
        {:else}
          <span class="text-gray-500 text-sm">Set a name</span>
        {/if}
      </p>
      <p class="text-sm text-gray-600">{sel.name}</p>
    </div>
  </div>
</div>
